import { Helmet } from 'react-helmet-async';
import { useMediaQuery } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import CompletedTickets from '../../components/dashboard/tickets/CompletedTickets';
import OpenTickets from '../../components/dashboard/tickets/OpenTickets';
import MobileTicketsView from '../../components/dashboard/tickets/mobile/MobileTicketsView';

export default function Tickets() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <>
      <Helmet>
        <title>Tickets | Platform Solutions</title>
      </Helmet>
      {isMobile ? <MobileTicketsView /> :status !== 'complete' ? <OpenTickets /> : <CompletedTickets />}
    </>
  );
}
